import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./BlogSub.css";
import API_BASE_URL from "../../config";

const BlogSub = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setError(null);
      fetch(`${API_BASE_URL}/blogs/${slug}`)
        .then((res) => {
          if (!res.ok) throw new Error("Blog not found");
          return res.json();
        })
        .then((data) => {
          console.log(data);
          setBlog(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }, 400);
  }, [slug]);

  // if (loading) return <p>Loading blog...</p>;
  if (error) return <p>Error: {error}</p>;
  // if (!blog) return <p>No blog data available.</p>;

  // Render section content (content.sections)
  const renderSection = (section, idx) => (
    <div key={idx} className="blog-section">
      {section.image && (
        <img
          src={section.image}
          alt={section.heading || "blog image"}
          className={`blog-main-image ${loaded ? "show" : ""}`}
          style={{
            display:
              section.image.align === "center" ? "block" : "inline-block",
            margin: section.image.align === "center" ? "20px auto" : "20px 0",
            float:
              section.image.align !== "center"
                ? section.image.align
                : undefined,
            width: section.image.width ? `${section.image.width}px` : "auto",
            height: section.image.height ? `${section.image.height}px` : "auto",
            // maxWidth: "700px",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
          // onLoad={(e) => e.currentTarget.classList.add("show")}
          onLoad={() => setLoaded(true)}
        />
      )}
      {section.heading && <h2>{section.heading}</h2>}
      {/* {section.text &&
        section.text.split("\n").map((para, i) => <p key={i}>{para}</p>)} */}
      {section.text &&
        section.text
          .split("\n")
          .map((para, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: para }}></p>
          ))}
    </div>
  );

  return (
    <>
      {loading ? (
        <div
          className="custom-loader"
          style={{
            height: "65vh",
            width: "100vw",
            position: "relative",
            zIndex: "1",
          }}
        >
          <div className="dots-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        <div className="blog-container">
          <div className="blog-header">
            {blog.image_url && (
              <img
                src={blog.image_url}
                alt="Main visual"
                className="blog-main-image"
                onLoad={(e) => e.currentTarget.classList.add("show")}
              />
            )}
            <h1 className="blog-title">{blog.title}</h1>
            {blog.description && (
              <p className="blog-subtitle">{blog.description}</p>
            )}
            <p className="blog-meta">
              Updated At : {new Date(blog.created_at).toLocaleDateString()}
              {/* &bull;{" "} */}
              {/* {blog.author || "Unknown Author"} */}
            </p>
          </div>

          <div
            className="blog-content"
            dangerouslySetInnerHTML={{
              __html: blog?.content,
            }}
          ></div>

          {/* {Array.isArray(blog.content?.sections) &&
            blog.content.sections.length > 0 ? (
              blog.content.sections.map((section, idx) =>
                renderSection(section, idx)
              )
            ) : (
              <p>No detailed content available.</p>
            )} */}
        </div>
      )}
    </>
  );
};

export default BlogSub;
